import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  Image,
  Button,
  Icon,
  Modal,
  Table,
  TableCell,
} from "semantic-ui-react";
import { image } from "../../../../assets";
import { Site } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmDialog } from "../../../Shared";
import { ENV } from "../../../../utils";
import { SiteForm } from "../SiteForm";
import "./SiteItem.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";

const siteController = new Site();

export function SiteItem(props) {
  const { site, onReload, permissionsByRole } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // Estado para abrir/cerrar el modal
  const [contentModal, setContentModal] = useState("");
  const [rowMenu, setRowMenu] = useState(null); // { top, left, openUp } | null

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  useEffect(() => {
    if (!rowMenu) return;
    const handler = (e) => {
      if (!e.target.closest(".site-item__row-menu, .site-item__row-menu-list")) setRowMenu(null);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [rowMenu]);

  const toggleRowMenu = (e) => {
    if (rowMenu) { setRowMenu(null); return; }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuHeight = 150;
    const openUp = rect.bottom + menuHeight > window.innerHeight;
    setRowMenu({
      left: rect.right - 170,
      top: openUp ? rect.top - 4 : rect.bottom + 4,
      openUp,
    });
  };

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const openUpdateSite = () => {
    setTitleModal(`${t("update")} ${site.name ? site.name : ""}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmHeader("Activar/Desactivar");
    setConfirmMessage(
      site.active
        ? `Desactivar sitio "${site.name || ""}"`
        : `Activar sitio "${site.name || ""}"`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await siteController.updateSite(accessToken, site._id, {
        active: !site.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmHeader("Eliminar");
    setConfirmMessage(`¿Está seguro de eliminar el sitio "${site.name || ""}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await siteController.deleteSite(accessToken, site._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      setContentModal(error.msg);
      setModalOpen(true);
      onOpenCloseConfirm();
    
    }
  };

   // Manejador de cierre del modal
   const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Table.Row key={site._id}>
        <Table.Cell data-label={t("company_name")}>{site.name ? site.name : ""}</Table.Cell>
          <Table.Cell data-label={t("cuit")}>{site.cuit}</Table.Cell>
            <Table.Cell data-label={t("phone")}>{site.phone}</Table.Cell>
        <Table.Cell data-label={t("email")}>{site.email}</Table.Cell>
        <Table.Cell textAlign="center" data-label="" className="site-item__actions" onClick={(e) => e.stopPropagation()}>
          <div className="site-item__row-menu">
            <button type="button" className="site-item__row-menu-btn" onClick={toggleRowMenu} aria-label={t("actions")}>
              <Icon name="ellipsis vertical" />
            </button>
          </div>
          {rowMenu && ReactDOM.createPortal(
            <div
              className="site-item__row-menu-list"
              style={{
                position: "fixed",
                top: rowMenu.top,
                left: rowMenu.left,
                transform: rowMenu.openUp ? "translateY(-100%)" : "none",
              }}
            >
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "sites", "edit")) && (
                <button onClick={() => { openUpdateSite(); setRowMenu(null); }}>
                  <Icon name="pencil" />{t("edit")}
                </button>
              )}
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "sites", "edit")) && (
                <button onClick={() => { openDesactivateActivateConfim(); setRowMenu(null); }}>
                  <Icon name={site.active ? "ban" : "check"} />{site.active ? t("deactivate") : t("activate")}
                </button>
              )}
              {(isMaster(role) || isAdmin(role) ||
                hasPermission(permissionsByRole, role._id, "sites", "delete")) && (
                <button className="site-item__row-menu-item--danger" onClick={() => { openDeleteConfirm(); setRowMenu(null); }}>
                  <Icon name="trash" />{t("delete")}
                </button>
              )}
            </div>,
            document.body
          )}
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size={"small"}>
        <SiteForm close={onOpenCloseModal} onReload={onReload} site={site} />
      </BasicModal>

      <ConfirmDialog
        open={showConfirm}
        title={confirmHeader}
        message={confirmMessage}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        confirmLabel={t("accept")}
        cancelLabel={t("cancel")}
        confirmDanger={isDelete}
      />

       {/* Modal de advertencia si no hay datos */}
       <Modal open={modalOpen} onClose={closeModal} size="tiny">
        <Modal.Header>
          <Icon name="warning sign" /> Advertencia
        </Modal.Header>
        <Modal.Content>
          <p>{contentModal}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
